<template>
  <div class="popup-wrap fun-wallet-history-detail" :class="{ active: isActive }">
    <div class="popup-box max-w-480">
      <a class="popup-close" @click="hideHistoryModal"><i class="fa-solid fa-xmark" aria-hidden="true" /></a>

      <div class="form-popup popup-padding">
        <div class="row-frame dep-form-frame colu-12 currency-setting">
          <h4 class="register-title font-w-b text-center fs-24px">
            {{ $t("Bao.detail") }}
          </h4>

          <div class="popup-history-detail-container">
            <div class="popup-history">
              <div class="con-list">
                <div class="title fs-14px">
                  {{ $t("Bao.status") }}
                </div>
                <div class="con">
                  <div class="state-box fs-14px fw-700">
                    <span class="fs-14px">{{ item.status_label }}</span>
                  </div>
                </div>
              </div>

              <div class="con-list">
                <div class="title fs-14px">
                  <template v-if="type === 'depositRecord'">
                    {{ $t("Bao.deposit_for_record") }}
                  </template>
                  <template v-else>
                    {{ $t("Bao.withdrawal_appaly") }}
                  </template>
                </div>
                <div class="con">
                  <div class="state-box fs-14px fw-700">
                    <span class="fs-14px">
                      {{ item.request_amount | numberFormat }}
                    </span>
                    <img class="his-icon" :src="item.image">
                  </div>
                </div>
              </div>

              <div class="con-list">
                <div class="title fs-14px">
                  <template v-if="type === 'depositRecord'">
                    {{ $t("Bao.deposit_receive") }}
                  </template>
                  <template v-else>
                    {{ $t("Bao.withdrawal_receive") }}
                  </template>
                </div>
                <div class="con">
                  <div class="state-box fs-14px fw-700">
                    <span class="fs-14px">
                      <template v-if="type === 'depositRecord'">
                        {{ item.amount | numberFormat }}
                      </template>
                      <template v-else>
                        {{ item.real_amount | numberFormat }}
                      </template>
                    </span>
                    <img class="his-icon" :src="item.image">
                  </div>
                </div>
              </div>

              <div class="con-list">
                <div class="title fs-14px">
                  {{ $t("Bao.time") }}
                </div>
                <div class="con">
                  <div class="state-box fs-14px fw-700">
                    <span class="fs-14px">{{ item.formattedTime }}</span>
                  </div>
                </div>
              </div>

              <div class="con-list">
                <div class="title fs-14px">
                  {{ $t("Bao.ref_id") }}
                </div>
                <div class="con">
                  <div class="state-box fs-14px fw-700">
                    <span class="fs-14px">{{ item.ref_id }}</span>
                  </div>
                </div>
              </div>

              <div class="con-list">
                <div class="title fs-14px">
                  {{ $t("Bao.change") }}
                </div>
                <div class="con">
                  <div class="state-box fs-14px fw-700">
                    <span class="fs-14px">{{ item.exchange_rate | numberFormat }}</span>
                  </div>
                </div>
              </div>

              <div class="con-list">
                <div class="title fs-14px">
                  {{ $t("Bao.wallet_action") }}
                </div>
                <div class="con">
                  <div class="state-box fs-14px fw-700">
                    <span class="fs-14px"> {{ item.method }} {{ item.channel ? ' - ' + item.channel : '' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center">
            <a class="w-100" href="javascript:;">
              <button class="btn-primary btn-w-100" type="submit" @click="copyTransactionInfo">
                <span>{{ $t("Bao.copy") }}</span>
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showNotice } from '@/utils/tool'

export default {
  name: 'TransactionHistoryModal',
  props: {
    isActive: Boolean,
    item: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  methods: {
    hideHistoryModal() {
      this.$emit('hideHistoryModal')
    },
    async copyTransactionInfo() {
      try {
        const typeLabel = this.type === 'depositRecord'
          ? this.$t('Bao.deposit_for_record')
          : this.$t('Bao.withdrawal_for_record')

        const receiveAmount = this.type === 'depositRecord'
          ? this.$options.filters.numberFormat(this.item.amount)
          : this.$options.filters.numberFormat(this.item.real_amount)

        const copyText = `
${this.$t('Bao.status')}: ${this.item.status_label}
${typeLabel}: ${this.$options.filters.numberFormat(this.item.request_amount)}
${this.$t('Bao.receive')}: ${receiveAmount}
${this.$t('Bao.time')}: ${this.item.formattedTime}
${this.$t('Bao.ref_id')}: ${this.item.ref_id}
${this.$t('Bao.change')}: ${this.$options.filters.numberFormat(this.item.exchange_rate)}
${this.$t('Bao.wallet_action')}: ${this.item.method}${this.item.channel ? ' - ' + this.item.channel : ''}
        `.trim()

        // 複製到剪貼簿
        await navigator.clipboard.writeText(copyText)

        setTimeout(() => {
          showNotice(this.$t('Bao.copy_ok'))
        }, 200)
      } catch (err) {
        console.error('copy error:', err)

        // 降級方案：使用舊的複製方法
        this.fallbackCopy()
      }
    },
    fallbackCopy() {
      try {
        const typeLabel = this.type === 'depositRecord'
          ? this.$t('Bao.deposit_for_record')
          : this.$t('Bao.withdrawal_for_record')

        const receiveAmount = this.type === 'depositRecord'
          ? this.$options.filters.numberFormat(this.item.amount)
          : this.$options.filters.numberFormat(this.item.real_amount)

        const copyText = `
${this.$t('Bao.status')}: ${this.item.status_label}
${typeLabel}: ${this.$options.filters.numberFormat(this.item.request_amount)}
${this.$t('Bao.receive')}: ${receiveAmount}
${this.$t('Bao.time')}: ${this.item.formattedTime}
${this.$t('Bao.ref_id')}: ${this.item.ref_id}
${this.$t('Bao.change')}: ${this.$options.filters.numberFormat(this.item.exchange_rate)}
${this.$t('Bao.wallet_action')}: ${this.item.method}${this.item.channel ? ' - ' + this.item.channel : ''}
        `.trim()

        const textArea = document.createElement('textarea')
        textArea.value = copyText
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)

        setTimeout(() => {
          showNotice(this.$t('Bao.copy_ok'))
        }, 200)
      } catch (err) {
        console.error('copy error:', err)
      }
    }
  }
}
</script>
